import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import firebase from "firebase/app";
import { BootstrapVue } from 'bootstrap-vue'
import VueMeta from "vue-meta";
import Vuelidate from 'vuelidate'
import BlockUI from 'vue-blockui'
import * as Sentry from '@sentry/vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import 'firebase/messaging'
import VueI18n from 'vue-i18n'

import MessageBanner from '@/components/utils/MessageBanner'
import LoadingButton from "@/components/utils/LoadingButton"

Vue.component("MessageBanner", MessageBanner);
Vue.component("LoadingButton", LoadingButton);

Vue.config.productionTip = false;

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(BlockUI)
Vue.use(VueMeta);
Vue.use(require('vue-moment'));
Vue.use(VueLodash, { lodash: lodash })
Vue.use(require('vue-infinite-scroll'))
Vue.use(VueI18n)

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
};

firebase.initializeApp(firebaseConfig);

Vue.prototype.$messaging = null;
if (firebase.messaging.isSupported()) {
  Vue.prototype.$messaging = firebase.messaging()
  Vue.prototype.$messaging.usePublicVapidKey(process.env.VUE_APP_FIREBASE_VAPID);
  navigator.serviceWorker.register('/static/firebase-messaging-sw.js')
    .then((registration) => {
      Vue.prototype.$messaging.useServiceWorker(registration)
    })
}

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DNS,
  Vue
});

const i18n = new VueI18n({
  locale: navigator.language.split('-')[0],
  messages: {
    'de': require('./lang/de-DE.json'),
    'en': require('./lang/en-GB.json'),
    'es': require('./lang/es-ES.json'),
    'fr': require('./lang/fr-FR.json'),
    'it': require('./lang/it-IT.json')
  },
  fallbackLocale: 'en'
})

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
  i18n
});



// WEBPACK FOOTER //
// ./src/main.js